import { Injectable, Injector } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class CsrfTokenService {
  constructor(private injector: Injector) {}

  private get authService(): AuthService {
    return this.injector.get(AuthService);
  }

  getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${this.authService.getToken() ?? ''}`,
      'X-CSRF-TOKEN': this.authService.getCsrfToken() ?? '',
      'Content-Type': 'application/json'
    });
  }
}
